import { FC, MouseEventHandler } from 'react'
import { Button } from '@/root/ui/tuuleliinid'
import cn from 'classnames'
import { sanitizeHtml } from '@/root/shared-helpers'

interface InfoMessageContainerProps {
  ButtonText: string
  body: string
  onClick: MouseEventHandler<HTMLButtonElement>
  title?: string
}

export const InfoMessageContainer: FC<InfoMessageContainerProps> = ({ title, body, onClick, ButtonText }) => (
  <div
    className={cn('flex w-full max-w-screen-xl flex-col items-center gap-10 rounded-2xl bg-white pb-10 md:px-0', {
      'min-h-96 justify-center pt-10': !title,
    })}
  >
    {title && (
      <h1 className="bg-base flex h-28 w-full items-center justify-center text-2xl font-bold text-white">{title}</h1>
    )}
    <p
      className={cn('text-center text-base [&>a]:font-bold [&>a]:underline', {
        'max-w-full text-2xl': !title,
        'max-w-screen-sm text-lg': title,
      })}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(body) }}
    />
    <Button onClick={onClick} variant="contained" className="uppercase">
      {ButtonText}
    </Button>
  </div>
)
